const de = {
  lng_name: 'Deutsch',
  item_id_does_not_exist: 'Artikel {{id}} existiert nicht in Ihrer Kaltura-Artikelliste oder wurde gelöscht.',
  your_kaltura_item_list_is_empty: 'Ihre Kaltura-Artikelliste ist leer.',
  purchase: 'kaufen',
  purchased: 'gekauft',
  go_to: 'Gehe zu',
  login_signup: 'Einloggen/Anmelden',
  logout: 'Ausloggen',
  please_wait: 'Bitte warten...',
  thank_you_for_your_purchase: 'Danke für Ihren Einkauf',
  buy_more_channels: 'Kaufen Sie mehr Kanäle',
  go_to_premium_content: 'Gehe zum Premium-Inhalt',
  go_to_purchased_channels: 'Gehe zum gekauften Kanälen',
};

export default de;